import * as Types from './messaging_gql.generated';

import { ConversationFragment, CoachFragment, MemberFragment, MessageFragment } from './fragments.generated';
import { gql } from 'graphql.macro';
import { ConversationFragmentDoc, CoachFragmentDoc, MemberFragmentDoc, MessageFragmentDoc } from './fragments.generated';
import * as Apollo from '@apollo/client';
export type ConversationsQueryVariables = Types.Exact<{
  active?: Types.Maybe<Types.Scalars['Boolean']>;
}>;


export type ConversationsQuery = (
  { __typename?: 'Queries' }
  & { conversations?: Types.Maybe<(
    { __typename?: 'ConversationsRelayNode' }
    & { edges?: Types.Maybe<Array<Types.Maybe<(
      { __typename?: 'ConversationEdgeRelayNode' }
      & Pick<Types.ConversationEdgeRelayNode, 'cursor'>
      & { node?: Types.Maybe<(
        { __typename?: 'ConversationNode' }
        & ConversationFragment
      )> }
    )>>> }
  )> }
);


export const ConversationsDocument = gql`
    query conversations($active: Boolean) {
  conversations(active: $active) {
    edges {
      cursor
      node {
        ...conversation
      }
    }
  }
}
    ${ConversationFragmentDoc}
${CoachFragmentDoc}
${MemberFragmentDoc}
${MessageFragmentDoc}`;
export type ConversationsQueryResult = Apollo.QueryResult<ConversationsQuery, ConversationsQueryVariables>;